// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"Form_formContainer__F8llV","error":"Form_error__ktNwL"};